import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 报表填报
 */
export class ReportFillControllerSvr {
    constructor() {
        this.baseurl = 'ReportFillControllerSvr.assx/';
    }
    /**
     * 更具报表定制ID获取上报详情
     * token:String, formulateKeyId:String, orgCode:String
     */
    getNewReprotFillDetailByFormulateKeyId(token, formulateKeyId, orgCode){
        return request.post(this.baseurl + 'getNewReprotFillDetailByFormulateKeyId', Qs.stringify({ token:token, formulateKeyId:formulateKeyId, orgCode:orgCode }));
    }
    /**
     * 市局修改报表填报信息
     * token:String, data:ReprotFill
     */
     modifyReportFillByPower(token, data){
        return request.post(this.baseurl + 'modifyReportFillByPower', Qs.stringify({ token:token, data:(typeof data === 'undefined' || data === null) ? '' : data.toString() }));
    }
    /**
     * 判断是否展示提示框
     * token:String, reportFillId:String, orgCode:String
     */
     DisplayTable(token, reportFillId, orgCode){
        return request.post(this.baseurl + 'DisplayTable', Qs.stringify({ token:token, reportFillId:reportFillId, orgCode:orgCode }));
    }
    /**
     * 添加报表填报信息
     * token:String, data:ReprotFill
     */
    addReprotFill(token, data) {
        return request.post(this.baseurl + 'addReprotFill', Qs.stringify({
            token: token,
            data: (typeof data === 'undefined' || data === null) ? '' : data.toString()
        }));
    }

    
    /**
     * 获取上报进度
     * token:String, formluateKeyId:String
     */
    getReportRate(token, formluateKeyId){
        return request.post(this.baseurl + 'getReportRate', Qs.stringify({ token:token, formluateKeyId:formluateKeyId }));
    }


    /**
     * 查询报表报表提交填报信息
     * token:String, data:ReprotFill
     */
    commitReprotFill(token, data) {
        return request.post(this.baseurl + 'commitReprotFill', Qs.stringify({
            token: token,
            data: (typeof data === 'undefined' || data === null) ? '' : data.toString()
        }));
    }

    /**
     * 分页查询填报信息
     * token:String, param:ReprotFillQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean, isPage:boolean
     */
    getPageReprotFillList(token, param, startIndex, maxSize, resultTotalCount, isPage) {
        return request.post(this.baseurl + 'getPageReprotFillList', Qs.stringify({
            token: token,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString(),
            startIndex: startIndex,
            maxSize: maxSize,
            resultTotalCount: resultTotalCount,
            isPage: isPage
        }));
    }
    /**
     * 分页查询填报信息
     * token:String, param:ReprotFillQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean, isPage:boolean
     */
    getPageNewReprotFillList(token, param, startIndex, maxSize, resultTotalCount, isPage) {
        return request.post(this.baseurl + 'getPageReprotFillList', Qs.stringify({
            token: token,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString(),
            startIndex: startIndex,
            maxSize: maxSize,
            resultTotalCount: resultTotalCount,
            isPage: isPage
        }));
    }
    /**
     * 分页查询填报信息
     * token:String, param:ReprotFillQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean, isPage:boolean
     */
    getPageNewReprotFillList(token, param, startIndex, maxSize, resultTotalCount, isPage) {
        return request.post(this.baseurl + 'getPageNewReprotFillList', Qs.stringify({
            token: token,
            param: (typeof param === 'undefined' || param === null) ? '' : param.toString(),
            startIndex: startIndex,
            maxSize: maxSize,
            resultTotalCount: resultTotalCount,
            isPage: isPage
        }));
    }

    /**
     * 更具报表定制ID获取上报详情
     * token:String, formulateKeyId:String, orgCode: String
     */
    getReprotFillDetailByFormulateKeyId(token, formulateKeyId, orgCode) {
        return request.post(this.baseurl + 'getReprotFillDetailByFormulateKeyId', Qs.stringify({
            token: token,
            formulateKeyId: formulateKeyId,
            orgCode: orgCode
        }));
    }

    /**
     * 查询报表填报信息
     * token:String, KeyId:String
     */
    getReprotFillDetail(token, KeyId) {
        return request.post(this.baseurl + 'getReprotFillDetail', Qs.stringify({
            token: token,
            KeyId: KeyId
        }));
    }

    /**
     * 修改报表填报信息
     * token:String, data:ReprotFill
     */
    modifyReprotFill(token, data) {
        return request.post(this.baseurl + 'modifyReprotFill', Qs.stringify({
            token: token,
            data: (typeof data === 'undefined' || data === null) ? '' : data.toString()
        }));
    }
}